module.exports = __webpack_public_path__ + "static/media/Hair_2_brown.a35ccc8d.svg";